import React from 'react';

import { City } from 'proto/City';

import { useFilteredList } from '../__hooks/useFilteredList';
import styles from '../Location.module.scss';
import { LocationFilterType } from '../types';

import SimpleList from './SimpleList';

interface CityListProps {
    headline?: string;
    list: City[];
    filter: string;
    onSelection: (id: number) => void;
    currentSelection: Set<number>;
}

const CityList = ({
    filter,
    onSelection,
    currentSelection,
    list,
    headline,
}: CityListProps) => {
    const filteredList = useFilteredList(list, filter, currentSelection);
    if (!filteredList.length) {
        return null;
    }

    return (
        <>
            {headline && <div className={styles.Title}>{headline}</div>}
            <SimpleList
                list={filteredList}
                type={LocationFilterType.City}
                onSelection={onSelection}
                currentSelection={currentSelection}
            />
        </>
    );
};

export default CityList;
